const env = process.env.NODE_ENV;

import def from './default.ts';
import dev from './dev.ts';
import devFeature from './feature-dev.ts';
import live from './live.ts';
import liveFeature from './feature-live.ts';

let config: typeof def;

switch (env) {
  case 'dev':
    config = dev;
    break;
  case 'feature-dev':
    config = devFeature;
    break;
  case 'live':
    config = live;
    break;
  case 'feature-live':
    config = liveFeature;
    break;
  default:
    config = def;
}

export default config;
